module.exports = __webpack_public_path__ + "img/depmap_svg_V161.1131a3e0.svg";